import React, { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

import Screen from '@front/web-ui/src/components/screen/screen';

import bgImage from '../../assets/gradientHP.png';
import bgImage2 from '../../assets/gradientHP@2x.png';
import bgImage3 from '../../assets/gradientHP@3x.png';

const responsiveBackgroundImage = () => css`
  background-image: url(${bgImage});

  /* stylelint-disable  media-feature-name-no-vendor-prefix */

  /* @2x Images (Pixel Ratio of 1.25+) */
  @media only screen and (-o-min-device-pixel-ratio: 5/4),
    only screen and (-webkit-min-device-pixel-ratio: 1.25),
    only screen and (resolution >= 1.25dppx) {
    background-image: url(${bgImage2});
  }

  /* @3x Images (Pixel Ratio of 2.25+) */
  @media only screen and (-o-min-device-pixel-ratio: 9/4),
    only screen and (-webkit-min-device-pixel-ratio: 2.25),
    only screen and (resolution >= 2.25dppx) {
    background-image: image-url(${bgImage3});
  }
  /* stylelint-enable  media-feature-name-no-vendor-prefix */
`;

const StyledScreen = styled(Screen)`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 630px;
  background-size: 100% 100%;
  ${responsiveBackgroundImage()};

  /* The wanted syntax was causing a bug in Safari so I disabled it  */
  /* stylelint-disable  media-feature-range-notation */
  @media (min-width: 768px) {
    border-radius: 30px;
  }
  /* stylelint-enable  media-feature-range-notation */
`;

type GradientBackgroundWrapperProps = PropsWithChildren<{
  testID?: string;
  className?: string;
}>;

const GradientBackgroundWrapper = ({ children, testID, className }: GradientBackgroundWrapperProps) => (
  <StyledScreen testID={testID} className={className}>
    {children}
  </StyledScreen>
);

export default GradientBackgroundWrapper;
